export default {
  user: null,
  role: null,
  time: null,
  myidpass:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfbmFtZSI6IkJpcmQgQVBJIiwiaWF0IjoxNjMyMTI4NzA5fQ.FGiAl-T0kDStj-M6imNVFBYPufCXqs_YMaOCzvmBcgc",
};
